export function isUrlImageValid (url=""){
  var image = new Image();
  image.src = url;
  if (image.width == 0) {
     return false;
  } else {
     return true;
  }
}
